import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import Typography from "Components/CommonComponents/Typography";
import { ToastContextDispatch } from "Context/CommonContext";
import useViewAccess from "Pages/MySchedule/Hooks/useViewAccess";
import PlannedLectureListingCard from "Pages/MySchedule/TOCModal/PlannedLectureListingCard";
import PlannedLectureViewCard from "Pages/MySchedule/TOCModal/PlannedLectureViewCard";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import {
  useContext,
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import { useForm } from "react-hook-form";
import { Button, Spinner } from "reactstrap";
import styled from "styled-components";
import { Input, Switch } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  getAPIRequest,
  putPostRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import {
  BASE_URL,
  BATCH_COURSE_PL_NODE,
  GET_CHAPTER_NODE_DETAILS,
  PLANNED_LECTURES_NODES,
  PLANNED_LECTURE_LIST,
  POST_COVERED_SYLLABUS,
  REFRESH_PLANNED_LECTURES,
} from "utilFunctions/Constants/urlConstants";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import {
  getAllNodes,
  removeDuplicates,
  removeSubChildrenFromNodes,
} from "utilFunctions/helperFunctions/utilFunctions";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
const ScheduledDiv1 = styled<any>("div")`
  width: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "35%" : "20%"};
  border-right: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "1px solid #AFAFAF" : ""};
  background: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "#f5f5f5" : ""};
`;
const ScheduledDiv2 = styled<any>("div")`
  width: ${({ screen, mode }: any) =>
    ["lectureDetailTab"].includes(mode)
      ? "100%"
      : ["xs", "sm", "md"].includes(screen)
      ? "70%"
      : "80%"};
  height: ${({ screen, mode }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? ["mybatchSyllabus"].includes(mode)
        ? "calc(100% - 110px)"
        : "calc(100% - 160px)"
      : ""};
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "" : ""};
`;
const PLNodeViewOnly = styled<any>("div")`
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "4px 0px"};
  position: relative;
  margin-top: 0px;
  white-space: normal;
`;
const TOCModal = ({
  userInfo,
  selectedlecture,
  planneLecturedList,
  allCoveredTopics,
  plannedLecture,
  getPlannedLecture,
  screen,
  modalCloseHandler,
  mode,
  header,
  lecturePrecheckedNodes,
  setLecturePrecheckedNodes,
  ispaneopen,
  batchName,
  subject,
  isNewUI = false,
}: any) => {
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  const { isViewOnly } = useViewAccess({
    UserRoleAccess: [UserRoles.academicCounsellor],
  });
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [selectedPlannedLecture, setSelectedPlannedLecture] = useState<any>(
    planneLecturedList.find(
      (item: any) => item.isComplete === 2 || item.isComplete === 1
    ) || planneLecturedList[0]
  );
  const [loading, setLoading] = useState(false);
  const [allCourseNodes, setAllCourseNodes] = useState<any>(null);
  const [expandTopic, setExpandTopic] = useState<any>([]);
  const [allNodeIdsFinal, setAllNodeIdsFinal] = useState<any>([]);
  const [allNodeIdsInitial, setAllNodeIdsInitial] = useState<any>([]);
  const [checkedTopicCovered, setCheckedTopicCovered] = useState<any>([]);
  const [prevCheckedTopicCovered, setPrevCheckedTopicCovered] = useState<any>(
    []
  );
  const [chapterList, setChapterList] = useState([]);
  const [chapterLectureListing, setChapterLectureListing] = useState([
    ...planneLecturedList,
  ]);
  const [chapterTOCfullTree, setChapterTOCfullTree] = useState<any>([]);
  const [batchStatusId, setBatchStatusId] = useState(null);
  const [chapterNodeDetail, setChapterNodeDetail] = useState<any>([]);
  const [fullTOCRes, setFullTOCRes] = useState<any>(null);
  const [lectureListingLoader, setLectureListingLoader] =
    useState<boolean>(false);
  const [courseNodePL, setCourseNodePL] = useState<any>({});
  const [selectedType, setSelectedType] = useState({
    label: "Chapter",
    value: "chapter",
  });
  const [checkeds, setCheckeds] = useState(false);
  const [currentRevisionToMark, setCurrentRevisionToMark] = useState<
    number | string
  >("");
  const modalOpenTime = useRef<number>(Date.now());
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [isPLModeEnabled, setIsPLModeEnabled] = useState(true);

  const chapterNodePL = useMemo(() => {
    const mapping: any = {};
    if (
      selectedType.value !== "chapter" ||
      !chapterTOCfullTree ||
      chapterTOCfullTree.length === 0 ||
      !courseNodePL
    ) {
      return mapping;
    }

    const traverse = (node: any): Set<number> => {
      const plSet = new Set<number>();
      if (!node) return plSet;

      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          const childPls = traverse(child);
          childPls.forEach((pl) => plSet.add(pl));
        }
      }

      const selfPl = courseNodePL[String(node.key)];
      if (selfPl !== undefined && selfPl !== null) {
        plSet.add(Number(selfPl));
      }

      if (plSet.size > 0) {
        mapping[String(node.key)] = Array.from(plSet);
      }

      return plSet;
    };

    chapterTOCfullTree.forEach((rootNode: any) => {
      traverse(rootNode);
    });

    return mapping;
  }, [chapterTOCfullTree, courseNodePL, selectedType.value]);

  useEffect(() => {
    if (searchValue !== debouncedSearch) {
      setIsSearching(true);
    }
    const handler = setTimeout(() => {
      if (searchValue) {
        pushToDataLayerForGTM({
          event: "ag_sc_search_topic",
          SEARCH_TERM: searchValue,
        });
      }
      setDebouncedSearch(searchValue);
      setIsSearching(false);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);
  const { makeRequest: getChapterNodeDetail } = useGetApi(
    (data: any) => {
      if (data["data"] && data["data"]) {
        setChapterNodeDetail(data["data"]);
      } else {
        setChapterNodeDetail([]);
      }
    },
    (error: any) => {
      setChapterNodeDetail([]);
      if (error && error["response"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      }
    }
  );
  useEffect(() => {
    setChapterLectureListing([...planneLecturedList]);
    if (ispaneopen) {
      setSelectedPlannedLecture(
        planneLecturedList.find(
          (item: any) => item.isComplete === 2 || item.isComplete === 1
        ) || planneLecturedList[0]
      );
    }
  }, [planneLecturedList]);
  useEffect(() => {
    if (ispaneopen) {
      modalOpenTime.current = Date.now();
    }
  }, [ispaneopen]);
  useEffect(() => {
    getTopicNodeForPL(
      BASE_URL +
        BATCH_COURSE_PL_NODE +
        `?batchId=${selectedlecture.batchId}&courseId=${selectedlecture?.courseId}&batchName=${batchName}&subject=${subject}`
    );
  }, []);
  const sequenceMap = useMemo(() => {
    const map: any = {};
    chapterLectureListing.forEach((item: any, index: number) => {
      map[String(item.id)] = index + 1;
    });
    return map;
  }, [chapterLectureListing]);
  const getPlannedLectures = async (url: string) => {
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        if (response && response["data"] && response["data"]["data"]) {
          setChapterLectureListing(
            response["data"]["data"]["plannedLectureIdList"]
          );
          setSelectedPlannedLecture(
            response["data"]["data"]["plannedLectureIdList"]?.[0]
          );
        }
      },
      failure: (error: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error?.response?.data?.code == "NF"
              ? "No Topic Present for this lecture"
              : error.message,
        });
      },
    } as any);
  };
  useEffect(() => {
    setAllNodeIdsFinal([]);
    setAllNodeIdsInitial([]);
    setCheckedTopicCovered([]);
    setPrevCheckedTopicCovered([]);
    setCheckeds(false);

    if (selectedType.value === "plannedLectures") {
      const plannedUrl =
        BASE_URL +
        PLANNED_LECTURE_LIST +
        `?subject=${selectedlecture.subject}&batchId=${selectedlecture?.batchId}&courseId=${selectedlecture?.courseId}&offset=0&limit=150&batchName=${batchName}`;
      getPlannedLectures(plannedUrl);
      setChapterList([]);
    } else {
      getTopicCovered(
        BASE_URL +
          PLANNED_LECTURES_NODES +
          `?batchId=${selectedlecture.batchId}&courseId=${selectedlecture?.courseId}&fullToc=true`,
        false
      );
    }
  }, [selectedlecture]);
  useEffect(() => {
    if (selectedPlannedLecture != null && selectedPlannedLecture.id) {
      if (selectedType.value == "plannedLectures") {
        getTopicCovered(
          BASE_URL +
            PLANNED_LECTURES_NODES +
            `?batchId=${selectedlecture.batchId}&courseId=${selectedlecture?.courseId}&plannedLectureId=${selectedPlannedLecture.id}`,
          true
        );
        setChapterList([]);
      }
    }
  }, [selectedPlannedLecture]);
  useEffect(() => {
    if (
      batchStatusId != null &&
      selectedType.value != "plannedLectures" &&
      ["mybatchSyllabus", "myScheduleHome"].includes(mode) &&
      selectedPlannedLecture &&
      !String(selectedPlannedLecture.id).includes("revision") &&
      !String(selectedlecture?.syllabusStatus === "Marked")
    ) {
      getChapterNodeDetail(
        BASE_URL +
          GET_CHAPTER_NODE_DETAILS +
          `?batchStatusId=${batchStatusId}&chapterId=${selectedPlannedLecture.id}&courseId=${selectedlecture?.courseId}`
      );
    }
  }, [selectedPlannedLecture]);
  const getTopicCovered = async (url: string, isPlanned: boolean) => {
    setLoading(true);
    if (["mybatchSyllabus"].includes(mode)) {
      url = url + "&facultyDetails=true";
    }
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        setFullTOCRes(response?.["data"]?.["data"]);
        setCurrentRevisionToMark(
          response["data"]["data"]["revisionLectureToMark"]
        );
        const completedChapters =
          response?.["data"]?.["data"]?.completedChapters || [];
        if (
          response["data"] &&
          response["data"]["data"] &&
          response["data"]["data"]["courseToc"] &&
          response["data"]["data"]["courseToc"].length
        ) {
          setBatchStatusId(response["data"]["data"]?.batchStatusId);
          const arr = response["data"]["data"]["courseToc"].map((ele: any) => {
            const cptr = completedChapters.filter(
              (el: any) => el.nodeId === ele.key
            );
            return {
              id: ele.key,
              isComplete: cptr && cptr?.[0]?.marked ? cptr?.[0]?.marked : 1,
            };
          });
          if (
            selectedlecture["revisionRank"] &&
            selectedlecture["revisionRank"] != null &&
            selectedlecture["revisionRank"] != 0 &&
            ["myScheduleHome"].includes(mode)
          ) {
            arr.push({
              id: "revision_" + selectedlecture["revisionRank"],
              isComplete: 3,
            });
          } else if (
            ["myScheduleHome"].includes(mode) &&
            response["data"]["data"]["revisionLectureToMark"] &&
            response["data"]["data"]["revisionLectureToMark"] != null &&
            response["data"]["data"]["revisionLectureToMark"] != 0 &&
            (selectedlecture["revisionRank"] == undefined ||
              selectedlecture["revisionRank"] == null ||
              selectedlecture["revisionRank"] == 0) &&
            selectedlecture["syllabusStatus"] != "Marked"
          ) {
            arr.push({
              id:
                "revision_" + response["data"]["data"]["revisionLectureToMark"],
              isComplete: 1,
            });
          }
          if (isPlanned) {
            setChapterList([]);
          } else {
            setChapterLectureListing(arr);
            setSelectedPlannedLecture(
              arr.find(
                (item: any) => item.isComplete === 2 || item.isComplete === 1
              ) || arr[0]
            );
          }
          if (isPlanned) {
            setAllCourseNodes(response["data"]["data"]["courseToc"]);
          } else {
            const chapterData = response["data"]["data"]["courseToc"];
            const chap =
              arr.find(
                (item: any) => item.isComplete === 2 || item.isComplete === 1
              ) || arr[0];
            const firstChapter = chap?.id;
            const filyteredData = chapterData.filter(
              (item: any) => item.key == firstChapter
            );
            //render revision list nodes if all chapter are marked
            setChapterTOCfullTree([...chapterData]);
            if (String(chap?.id).includes("revision")) {
              const currentRevision = parseInt(String(chap?.id).split("_")[1]);
              const allCourseArray: any = [];
              for (let i = 1; i <= currentRevision; i++) {
                allCourseArray.push({
                  id: "revision_" + i,
                  title: "Revision Lecture " + i,
                  label: "Revision Lecture " + i,
                  key: "revision_" + i,
                  nodeType: "Chapter",
                });
              }
              setAllCourseNodes([...allCourseArray]);
            } else {
              setAllCourseNodes(removeSubChildrenFromNodes(filyteredData));
            }
          }
        } else {
          setChapterList([]);
          setAllCourseNodes(null);
        }
        const nodeIdsMarkedRes = response["data"]["data"]["nodeIdsMarked"];
        const expandedkeys = response["data"]["data"]["courseToc"]?.map(
          (item: any) => {
            if (item) {
              return String(item.key);
            }
          }
        );
        if (
          ["myScheduleHome"].includes(mode) &&
          selectedlecture["revisionRank"] &&
          selectedlecture["revisionRank"] != null &&
          selectedlecture["revisionRank"] != 0
        ) {
          const currentRevisionId = selectedlecture["revisionRank"];
          for (let i = 1; i <= currentRevisionId; i++) {
            nodeIdsMarkedRes.push("revision_" + i);
          }
        } else if (
          ["myScheduleHome"].includes(mode) &&
          response["data"]["data"]["revisionLectureToMark"] &&
          response["data"]["data"]["revisionLectureToMark"] != null &&
          response["data"]["data"]["revisionLectureToMark"] != 0 &&
          (selectedlecture["revisionRank"] == undefined ||
            selectedlecture["revisionRank"] == null ||
            selectedlecture["revisionRank"] == 0) &&
          selectedlecture["syllabusStatus"] != "Marked"
        ) {
          const currentRevisionId =
            response["data"]["data"]["revisionLectureToMark"];
          for (let i = 1; i < currentRevisionId; i++) {
            nodeIdsMarkedRes.push("revision_" + i);
          }
        }
        if (
          nodeIdsMarkedRes &&
          Array.isArray(nodeIdsMarkedRes) &&
          nodeIdsMarkedRes.length > 0
        ) {
          setCheckedTopicCovered(
            nodeIdsMarkedRes.map((item: any) => String(item))
          );
          setPrevCheckedTopicCovered(
            nodeIdsMarkedRes.map((item: any) => String(item))
          );
        } else {
          setCheckedTopicCovered([]);
          setPrevCheckedTopicCovered([]);
        }

        if (isPlanned) {
          const data = response["data"]["data"][
            "plannedLectureMarkedNodes"
          ].map((item: any) => String(item));
          const existingNodes = new Set(allNodeIdsFinal);
          const newData = data.filter((item: any) => !existingNodes.has(item));
          setAllNodeIdsFinal((prev: any) => [...prev, ...newData]);
          const existingNodesInital = new Set(allNodeIdsInitial);
          const nodesInitialData = data.filter(
            (item: any) => !existingNodesInital.has(item)
          );
          setAllNodeIdsInitial((prev: any) => [...prev, ...nodesInitialData]);
        } else {
          const data = (nodeIdsMarkedRes || []).map((item: any) =>
            String(item)
          );
          const existingNodesInital = new Set(allNodeIdsInitial);
          const nodesInitialData = data.filter(
            (item: any) => !existingNodesInital.has(item)
          );
          setAllNodeIdsInitial((prev: any) => [...prev, ...nodesInitialData]);
        }
        setExpandTopic(expandedkeys);
        setLoading(false);
      },
      failure: (error: any) => {
        setAllCourseNodes(null);
        setChapterList([]);
        setCheckedTopicCovered([]);
        setPrevCheckedTopicCovered([]);
        setAllNodeIdsFinal([]);
        setLectureListingLoader(false);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error?.response?.data?.code == "NF"
              ? "No Topic Present for this lecture"
              : error.message,
        });
      },
    } as getRequestInterface);
  };

  const getTopicNodeForPL = async (url: string) => {
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        if (response.data) setCourseNodePL(response.data.data);
      },
      failure: (error: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error?.response?.data?.code == "NF" ? "No PL found" : error.message,
        });
      },
    } as getRequestInterface);
  };
  const PostRefreshPlannedLectures = (
    url: string,
    data: any,
    selectedPlannedLecture: any
  ) => {
    putPostRequest({
      url: url,
      success: (data: any) => {
        const res = data["data"];
        console.log("res", res);
      },
      failure: (err: any) => {
        console.log(err);
        if (selectedPlannedLecture) {
          getTopicCovered(
            BASE_URL +
              PLANNED_LECTURES_NODES +
              `?batchId=${selectedlecture?.batchId}&courseId=${selectedlecture?.courseId}&plannedLectureId=${selectedPlannedLecture.id}`,
            true
          );
        }
      },
      body: data,
      method: "Post",
    } as any);
  };
  const onSelectedChange = (selected: any) => {
    setSelectedType(selected);
    setLectureListingLoader(true);
    if (selected.label === "Chapter") {
      getTopicCovered(
        BASE_URL +
          PLANNED_LECTURES_NODES +
          `?batchId=${selectedlecture.batchId}&courseId=${selectedlecture?.courseId}&plannedLectureId=${selectedPlannedLecture?.id}&fullToc=true`,
        false
      );
    } else {
      const obj = {
        batchId: selectedlecture.batchId,
        courseId: selectedlecture?.courseId,
      };
      const url = BASE_URL + REFRESH_PLANNED_LECTURES;
      const selectedPlannedLecture =
        planneLecturedList.find(
          (item: any) => item.isComplete === 2 || item.isComplete === 1
        ) || planneLecturedList[0];
      PostRefreshPlannedLectures(url, obj, selectedPlannedLecture);
      setTimeout(() => {
        const plannedUrl =
          BASE_URL +
          PLANNED_LECTURE_LIST +
          `?subject=${selectedlecture.subject}&batchId=${selectedlecture?.batchId}&courseId=${selectedlecture?.courseId}&offset=0&limit=150&batchName=${batchName}`;
        getPlannedLecture(plannedUrl);
      }, 10);
      setSelectedPlannedLecture(selectedPlannedLecture);
      setChapterLectureListing([...planneLecturedList]);
      if (allCourseNodes) {
        setAllCourseNodes([...allCourseNodes]);
      }
      setChapterList([]);
    }
    setLectureListingLoader(false);
  };
  const handleSelectedChapter = (ele: any) => {
    const firstChapter = ele.id;
    const filyteredData = chapterTOCfullTree.filter(
      (item: any) => item.key == firstChapter
    );
    const expandedkeys = filyteredData?.map((item: any) => {
      if (item) {
        return String(item.key);
      }
    });
    setExpandTopic(expandedkeys);
    if (String(ele.id).includes("revision")) {
      const currentRevision = parseInt(String(ele.id).split("_")[1]);
      const allCourseArray: any = [];
      for (let i = 1; i <= currentRevision; i++) {
        allCourseArray.push({
          id: "revision_" + i,
          title: "Revision Lecture " + i,
          label: "Revision Lecture " + i,
          key: "revision_" + i,
          nodeType: "Chapter",
        });
      }
      setAllCourseNodes([...allCourseArray]);
    } else {
      setAllCourseNodes(removeSubChildrenFromNodes(filyteredData));
    }
    setSelectedPlannedLecture(ele);
  };

  console.log("chapterNodePL====", chapterNodePL);

  const hasSearchMatch = useCallback(
    (node: any, query: string): boolean => {
      if (!query) return true;

      const isPresentPL =
        !isPLModeEnabled || !courseNodePL || !!courseNodePL[String(node.key)];

      const isPresentSearch = node.title
        ?.toLowerCase()
        .includes(query.toLowerCase());

      if (isPresentPL && isPresentSearch) {
        return true;
      }

      if (node.children && node.children.length > 0) {
        return node.children.some((child: any) => hasSearchMatch(child, query));
      }
      return false;
    },
    [isPLModeEnabled, courseNodePL]
  );

  const filteredChapterLectureListing = useMemo(() => {
    if (!debouncedSearch) return chapterLectureListing;
    return chapterLectureListing.filter((chapterItem: any) => {
      if (String(chapterItem.id).includes("revision")) {
        const revisionTitle = `Revision Lecture ${
          String(chapterItem.id).split("_")[1] || ""
        }`;
        return revisionTitle
          .toLowerCase()
          .includes(debouncedSearch.toLowerCase());
      }
      const chapterNode = chapterTOCfullTree.find(
        (node: any) => String(node.key) === String(chapterItem.id)
      );
      if (!chapterNode) return false;
      return hasSearchMatch(chapterNode, debouncedSearch);
    });
  }, [
    chapterLectureListing,
    chapterTOCfullTree,
    debouncedSearch,
    hasSearchMatch,
  ]);

  useEffect(() => {
    if (selectedType.value === "chapter") {
      if (debouncedSearch) {
        if (filteredChapterLectureListing.length > 0) {
          const isSelectedStillPresent = filteredChapterLectureListing.some(
            (item: any) => item.id === selectedPlannedLecture?.id
          );
          if (!isSelectedStillPresent) {
            handleSelectedChapter(filteredChapterLectureListing[0]);
          }
        } else {
          setSelectedPlannedLecture(null);
          setAllCourseNodes([]);
        }
      } else {
        if (!selectedPlannedLecture && chapterLectureListing.length > 0) {
          handleSelectedChapter(chapterLectureListing[0]);
        }
      }
    }
  }, [
    debouncedSearch,
    filteredChapterLectureListing,
    selectedPlannedLecture,
    selectedType.value,
  ]);

  const { makeRequest: postTopicCovered } = usePutPostAPI(
    (data: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Success",
        message: data["detailMessage"] || data["message"],
      });
      const durationSeconds = Math.round(
        (Date.now() - modalOpenTime.current) / 1000
      );
      pushToDataLayerForGTM({
        event: "ag_sc_mark_syllabus_topic_popup",
        LECTURE_ID:
          selectedlecture?.fexRecordId ?? selectedlecture?.batchTimeTableId,
        BATCH_ID: selectedlecture?.batchId,
        COURSE_ID: selectedlecture?.courseId,
        TOPICS_MARKED_COUNT: checkedTopicCovered.length,
        TOPICS_UNMARKED_COUNT: 0,
        MARKING_METHOD: "manual",
        IS_EDITABLE: !isViewOnly,
        DURATION_SECONDS: durationSeconds,
      });
      modalCloseHandler();
      setTimeout(() => {
        const plannedUrl =
          BASE_URL +
          PLANNED_LECTURE_LIST +
          `?subject=${selectedlecture.subject}&batchId=${selectedlecture?.batchId}&courseId=${selectedlecture?.courseId}&offset=0&limit=150&batchName=${batchName}`;
        getPlannedLecture(plannedUrl);
      }, 10);
    },
    (error) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          error["response"]["data"]["internalCode"] ||
          error["response"]["data"]["message"],
      });
    },
    "PUT"
  );
  const handleCheckedNodes = (data: any) => {
    // set all previous nodes and new nodes
    const newDataArray = [...allNodeIdsFinal, ...data];
    setAllNodeIdsFinal(newDataArray);
    //
    const newDataArray2 = [...checkedTopicCovered, ...data];
    setAllNodeIdsFinal(removeDuplicateFromArray(newDataArray2));

    setCheckedTopicCovered(data);
  };
  const handleRemoveUnCheckKey = (data: any) => {
    // remove node from finalNode
    const allNodeIdsFinalArr = [...allNodeIdsFinal];
    const filteredNodeIdFinal = allNodeIdsFinalArr.filter(
      (item: any) => item != data
    );
    setAllNodeIdsFinal(filteredNodeIdFinal);
    //
    const checkKeysArray = [...checkedTopicCovered];
    const filteredChecked = checkKeysArray.filter((item: any) => item != data);
    setCheckedTopicCovered([...filteredChecked]);
  };
  function arraysEqual(arr1: any, arr2: any) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    return arr1.every((element: any, index: any) => element === arr2[index]);
  }

  const handleSaveTopoic = (data: any) => {
    const keysToSave = data.map((item: any) => Number(item));
    // const initialSave = allNodeIdsInitial.map((item: any) => Number(item));
    if (arraysEqual(removeDuplicates(allNodeIdsInitial), data)) {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "Please choose node",
      });
    } else {
      const obj = {
        // nodeIdsInitial: removeDuplicates(initialSave),
        nodeIdsFinal: removeDuplicates(keysToSave),
        courseId: selectedlecture.courseId,
        facultyId: userInfo?.employeeId,
        batchId: selectedlecture.batchId,
        eventId: selectedlecture.batchTimeTableId,
        lectureDate: selectedlecture.startTime,
        plId: selectedPlannedLecture.id,
      };
      const url = BASE_URL + POST_COVERED_SYLLABUS;
      postTopicCovered(url, obj);
    }
  };

  const handleSaveRevisionTopoic = (data: any) => {
    if (
      selectedlecture["syllabusStatus"] != "Marked" &&
      !data.some((el: any) => String(el).split("_")[1] == currentRevisionToMark)
    ) {
      return ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "Please choose node",
      });
    }
    const markedOrnot =
      data &&
      data.length &&
      data.includes("revision_" + selectedlecture["revisionRank"])
        ? true
        : false;
    // const initialSave = allNodeIdsInitial.map((item: any) => Number(item));
    const obj = {
      lectureId: selectedlecture.batchTimeTableId,
      toMark:
        selectedlecture["syllabusStatus"] != "Marked" ? true : markedOrnot,
    };
    const url = BASE_URL + "syllabusCompliance/markRevision";
    postTopicCovered(url, obj);
  };
  const handleOnlyCheckedNodes = (data: any) => {
    console.log(data, "datacheck");
  };

  const handleOnlyAllCheckedNodes = (data: any) => {
    console.log(data, "datacheck");
  };
  function removeDuplicateFromArray(arr: string[]): string[] {
    return Array.from(new Set(arr));
  }
  const onChange = (e: any, isPLMode?: boolean) => {
    setCheckeds(e.target.checked);
    const allNodes = getAllNodes(allCourseNodes)
      .map((ele: any) => {
        if (ele?.children == undefined || ele?.children?.length <= 0) {
          if (!isPLMode || (courseNodePL && courseNodePL[String(ele.key)])) {
            return String(ele.key);
          }
          return null;
        } else return null;
      })
      .filter((ele: any) => ele != null);

    const lecturePrecheckedNode =
      lecturePrecheckedNodes && lecturePrecheckedNodes != null
        ? lecturePrecheckedNodes.map(String)
        : [];

    if (e.target.checked) {
      const prevSelectedNodes: any = [];
      lecturePrecheckedNode.forEach((ele: any) => {
        if (allNodes.includes(ele)) {
          prevSelectedNodes.push(ele);
        }
      });
      const extraNodes: any = checkedTopicCovered.filter(
        (el: any) =>
          !lecturePrecheckedNodes.includes(el) &&
          allNodes.includes(el) &&
          !prevSelectedNodes.includes(el)
      );
      setCheckedTopicCovered([...checkedTopicCovered, ...allNodes]);
      const uniqueArray = extraNodes.filter(
        (value: any, index: number, self: any) => {
          return self.indexOf(value) === index;
        }
      );
      const removedNodes = allNodes
        .filter((ele: any) => !uniqueArray.includes(ele))
        .map(Number);
      setLecturePrecheckedNodes([...lecturePrecheckedNodes, ...removedNodes]);
    } else {
      const newArr: any = [];
      allNodes.forEach((ele: any) => {
        if (!prevCheckedTopicCovered.includes(ele)) {
          newArr.push(ele);
        }
      });
      const prevSelectedNodes: any = [];

      lecturePrecheckedNode.forEach((ele: any) => {
        if (allNodes.includes(ele)) {
          prevSelectedNodes.push(ele);
        }
      });
      const result = [...checkedTopicCovered].filter(
        (item) => !newArr.includes(item) && !prevSelectedNodes.includes(item)
      );
      setCheckedTopicCovered([...result]);
    }
  };
  console.log(chapterList);
  return (
    <>
      <div
        className={
          ["xs", "sm", "md"].includes(screen)
            ? "h-100 overflow-hidden"
            : "h-100"
        }
      >
        {["xs", "sm", "md"].includes(screen) && (
          <div className="pl-1 pb-3 pr-2 pt-2 selectLectureDiv">
            {" "}
            <SingleSelectHookForm
              disabled={false}
              error={errors}
              controlName={control}
              placeholder="Select role"
              width={"100%"}
              isInPerformance={false}
              options={[
                {
                  label: "Chapter",
                  value: "chapter",
                },
                {
                  label: "Planned Lectures",
                  value: "plannedLectures",
                },
              ]}
              menuPlacement="bottom"
              isClearable={false}
              isSearchable={true}
              isSearchableDrop={true}
              isDropdownSelect={true}
              top={"0px"}
              menuShouldScrollIntoView={true}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              isBorder={false}
              name={"fexRole"}
              register={register}
              rules={{
                required: "You must select user role.",
              }}
              onChange={(selected: any) => {
                onSelectedChange(selected);
              }}
              defaultValue={[selectedType]}
            />
          </div>
        )}
        {!["xs", "sm", "md"].includes(screen) &&
          ["myScheduleHome"].includes(mode) && <>{header}</>}
        {selectedType.value === "chapter" &&
          ["myScheduleHome"].includes(mode) && (
            <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
              <div
                style={{
                  width: ["xs", "sm", "md"].includes(screen) ? "100%" : "100%",
                }}
                className={`d-flex justify-content-between pb-2 pt-0 pr-0 align-items-center ${
                  ["xs", "sm", "md"].includes(screen) ? "pl-1" : "pl-0"
                }`}
              >
                <div
                  style={{
                    width: ["xs", "sm", "md"].includes(screen)
                      ? "70%"
                      : "350px",
                  }}
                >
                  <Input
                    name="search"
                    placeholder="Search"
                    className="w-100"
                    prefix={<SearchOutlined />}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    allowClear
                  />
                </div>
                <div className="pr-2 d-flex gap-2 w-40 justify-content-end align-items-center">
                  <span
                    style={{
                      fontSize: ["xs", "sm", "md"].includes(screen)
                        ? "13px"
                        : "14px",
                    }}
                  >
                    PL Mode
                  </span>
                  <Switch
                    checked={isPLModeEnabled}
                    onChange={(val: boolean) => {
                      setIsPLModeEnabled(val);
                      if (val) {
                        const newValuesChecked: any = [];
                        const plChecked = Object.keys(courseNodePL);
                        [...checkedTopicCovered].forEach((key) => {
                          if (plChecked.includes(key)) {
                            newValuesChecked.push(key);
                          }
                        });
                        setCheckedTopicCovered(newValuesChecked);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        <div
          className={
            ["xs", "sm", "md"].includes(screen)
              ? "d-flex flex-row h-100 w-100"
              : "d-flex flex-row gap-3 h-100 pb-7 w-100"
          }
        >
          {lectureListingLoader ? (
            <Spinner color="info"></Spinner>
          ) : (
            <>
              {["lectureDetailTab"].includes(mode) ? null : (
                <ScheduledDiv1 screen={screen} mode={mode}>
                  <PlannedLectureListingCard
                    planneLecturedList={filteredChapterLectureListing}
                    setSelectedPlannedLecture={setSelectedPlannedLecture}
                    selectedPlannedLecture={selectedPlannedLecture}
                    selectedType={selectedType}
                    setSelectedType={setSelectedType}
                    setAllCourseNodes={setAllCourseNodes}
                    plannedLecture={plannedLecture}
                    handleSelectedChapter={handleSelectedChapter}
                    onSelectedChange={onSelectedChange}
                    screen={screen}
                    mode={mode}
                    fullTOCRes={fullTOCRes}
                    chapterNodePL={chapterNodePL}
                    sequenceMap={sequenceMap}
                  />
                </ScheduledDiv1>
              )}
            </>
          )}
          <ScheduledDiv2 screen={screen} mode={mode}>
            {selectedPlannedLecture != null && (
              <>
                {loading ? (
                  <div>
                    <Spinner color="info"></Spinner>
                  </div>
                ) : (
                  <PlannedLectureViewCard
                    mode={mode}
                    isMarkedAsRevision={
                      selectedlecture["revisionRank"] &&
                      selectedlecture["revisionRank"] != null &&
                      selectedlecture["revisionRank"] != 0 &&
                      selectedlecture["syllabusStatus"] == "Marked"
                    }
                    isRevisionChapterSelected={
                      selectedPlannedLecture &&
                      String(selectedPlannedLecture.id).includes("revision")
                    }
                    selectedPlannedLecture={selectedPlannedLecture}
                    expandTopic={expandTopic}
                    checkedTopicCovered={
                      selectedType.value == "plannedLectures"
                        ? allNodeIdsFinal.length > 0
                          ? [...checkedTopicCovered, ...allNodeIdsFinal]
                          : checkedTopicCovered
                        : checkedTopicCovered
                    }
                    allCoveredTopics={allCoveredTopics}
                    lecturePrecheckedNodes={lecturePrecheckedNodes}
                    allCourseNodes={allCourseNodes}
                    handleCheckedNodes={handleCheckedNodes}
                    handleOnlyCheckedNodes={handleOnlyCheckedNodes}
                    handleRemoveUnCheckKey={handleRemoveUnCheckKey}
                    handleOnlyAllCheckedNodes={handleOnlyAllCheckedNodes}
                    screen={screen}
                    header={header}
                    chapterNodeDetail={chapterNodeDetail}
                    courseNodePL={courseNodePL}
                    isPlannedMode={
                      selectedType.value == "plannedLectures" ? true : false
                    }
                    checkeds={checkeds}
                    setCheckeds={setCheckeds}
                    onChange={onChange}
                    prevCheckedTopicCovered={prevCheckedTopicCovered}
                    debouncedSearch={debouncedSearch}
                    isSearching={isSearching}
                    isPLModeEnabled={isPLModeEnabled}
                  />
                )}
              </>
            )}
          </ScheduledDiv2>
        </div>
        {!["xs", "sm", "md"].includes(screen) &&
          ["myScheduleHome"].includes(mode) &&
          !isNewUI && (
            <div
              style={{
                marginTop: "-93px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {["myScheduleHome"].includes(mode) &&
                selectedType.value == "plannedLectures" && (
                  <PLNodeViewOnly className="pl-0">
                    <Typography variant="label" color="gray">
                      <strong>Note :</strong> Planned lecture view is not
                      markable. You need to mark the topics covered in the
                      lecture in CHAPTER only.
                    </Typography>
                  </PLNodeViewOnly>
                )}
              {["myScheduleHome"].includes(mode) &&
                selectedType.value != "plannedLectures" && (
                  <PLNodeViewOnly className="pl-0">
                    <Typography variant="label" color="gray">
                      <strong>Note :</strong> Mark the topics covered in the
                      lecture & save. System will auto-generate your compliance
                      report.
                    </Typography>
                  </PLNodeViewOnly>
                )}
              {selectedType.value == "plannedLectures" ? null : (
                <div>
                  <Button
                    color="aeslPrimary"
                    size="sm"
                    disabled={isViewOnly || !selectedPlannedLecture}
                    onClick={() => {
                      if (
                        selectedPlannedLecture &&
                        String(selectedPlannedLecture.id).includes("revision")
                      ) {
                        handleSaveRevisionTopoic(
                          selectedType.value == "plannedLectures"
                            ? allNodeIdsFinal
                            : checkedTopicCovered
                        );
                      } else {
                        handleSaveTopoic(
                          selectedType.value == "plannedLectures"
                            ? allNodeIdsFinal
                            : checkedTopicCovered
                        );
                      }
                    }}
                  >
                    {" "}
                    Mark for {selectedlecture?.eventName}
                  </Button>
                </div>
              )}
            </div>
          )}
      </div>
      {["xs", "sm", "md"].includes(screen) &&
        ["myScheduleHome"].includes(mode) &&
        !isNewUI && (
          <div className="filterFooter">
            <Button
              color={"aeslPrimary"}
              className="w-100"
              onClick={() => {
                if (
                  selectedPlannedLecture &&
                  String(selectedPlannedLecture.id).includes("revision")
                ) {
                  handleSaveRevisionTopoic(
                    selectedType.value == "plannedLectures"
                      ? allNodeIdsFinal
                      : checkedTopicCovered
                  );
                } else {
                  handleSaveTopoic(
                    selectedType.value == "plannedLectures"
                      ? allNodeIdsFinal
                      : checkedTopicCovered
                  );
                }
              }}
              disabled={isViewOnly || !selectedPlannedLecture}
            >
              Mark for {selectedlecture?.eventName}
            </Button>
          </div>
        )}
    </>
  );
};
export default TOCModal;
